<template>
  <div>
    <multiple_form
      :forms="forms"
      :edit="props.isEdit"
      :editData="props.editData"
      @submit="handelSubmit"
      v-if="!props.isViewRoute"
    >
      <locations_map
        :isView="props.isViewRoute"
        v-model="locationList"
        :points="props.allLocations"
        style="height: calc(100vh - 158px) !important"
      ></locations_map>
    </multiple_form>
    <locations_map
      v-else
      v-model="locationList"
      :isView="props.isViewRoute"
      :points="props.allLocations"
      style="height: calc(100vh - 108px) !important"
    ></locations_map>
  </div>
</template>
<script setup>
  import { defineProps, defineEmits, computed, ref, onMounted } from 'vue'
  import { message } from 'ant-design-vue'
  import { createData, updateData, getAllLocation } from '@/api/car_route'
  import multiple_form from '@/components/multiple_form'
  import locations_map from '@/components/map/locations_map'
  //初始化
  const props = defineProps({
    isEdit: Boolean,
    isViewRoute: Boolean,
    editData: Object,
    data: Array,
    allLocations: Array,
    idField: String,
  })
  const emit = defineEmits(['submit'])

  //编辑、新增的表单
  const forms = computed(() => [
    {
      id: 'car_person',
      itemWidth: '420px',
      formItem: [
        // {
        //   type: 'input',
        //   field: 'name',
        //   label: '路线名称',
        // },
        // {
        //   type: 'input',
        //   field: 'locationIds',
        //   label: '点位id',
        // },
      ],
    },
  ])

  //路径点位数据
  const locationList = ref(props.editData?.locations)

  async function handelSubmit(data) {
    const ajaxFn = props.isEdit ? updateData : createData
    const messageText = '编辑点位'
    const id = props.isEdit
      ? { [props.idField]: props.editData[props.idField] }
      : {}

    const res = await ajaxFn({
      ...props.editData,
      ...data,
      ...id,
      locationIds: locationList.value.toString(),
    })
    if (res.success) {
      message.success(messageText + '成功！')
      emit('success')
    } else {
      message.warn(messageText + '错误：', res.message)
    }
  }
</script>
